const ProfileCommunications = (function ProfileCommunications() {
  const componentCheck = document.querySelector('.user-profile .sub-options .checkbox-grid');
  const labelHolders = Array.from(document.querySelectorAll('.clutch-submission .label-holder'));

  labelHolders.forEach((container) => {
    container.toggle = container.querySelector('.toggle-button > .checkbox');
    container.subOptionsContainer = container.querySelector('.sub-options');
    container.subCheckboxes = Array.from(container.querySelectorAll('.sub-options .custom-checkbox-input'));
  });

  function attachEvents() {
    for (const container of labelHolders) {
      const { toggle, subOptionsContainer } = container;

      if (!subOptionsContainer) {
        continue;
      }

      toggle.addEventListener('change', function() {
        this.checked
          ? subOptionsContainer.classList.remove('hidden')
          : subOptionsContainer.classList.add('hidden');

        if (this.checked === false) {
          const { subCheckboxes } = container;
          for (const checkbox of subCheckboxes) {
            checkbox.checked = false;
          }
        }
      })
    }
  }

  function check() {
    for (const container of labelHolders) {
      const { toggle, subOptionsContainer, subCheckboxes } = container;

      if (!subOptionsContainer) {
        continue;
      }

      if (!toggle.checked) {
        subOptionsContainer.classList.add('hidden');
      }

      subCheckboxes.some(checkbox => {
        if (checkbox.checked) {
          subOptionsContainer.classList.remove('hidden');
          toggle.checked = true;
        }
      });
    }
  }

  function init() {
    if (!componentCheck) {
      return;
    }
    attachEvents();
    check();
  }

  init();
}());
